import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const ConfirmationModal = ({ title,body, modal, buttons, setModal }) => {

    const toggle = () => setModal(!modal);

    return (
        <div>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                   {title}
                </ModalHeader>
                <ModalBody>
                    {typeof body === 'string' ? (
                        <div>
                            {body.split('<br />').map((line, index, array) => (
                                <React.Fragment key={index}>
                                    {line}
                                    {index < array.length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </div>
                    ) : (
                        body
                    )}
                </ModalBody>
                <ModalFooter>
                    {buttons.map((button) => {
                        return (
                            <Button
                              className={button.className}
                              onClick={() => button.onclick()}>
                              <i className={button.icon} aria-hidden="false" />{` ${button.title}`}
                            </Button>

                        )
                    })}
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ConfirmationModal;